import { action } from 'easy-peasy';

import { IActionSetPastVisits } from '../types';

const setPastVisits: IActionSetPastVisits = action((state, payload) => {
  state.pastVisits = payload;
});

export default setPastVisits;
